import * as actionTypes from "./actionTypes";
import { trackSimpleEvent } from "../../helpers/reduxBeacon";

const gaEventsMap = {
  ...trackSimpleEvent(actionTypes.REQUEST_NEW_ORDER) // TODO: timings
};

export default gaEventsMap;
